import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Modal,
  message,
  Tooltip,
  Spin,
  Checkbox,
  Space,
  InputNumber,
  Divider,
} from 'antd';
import {
  MYCREATESTATUS,
  renderCardStatusColor,
  renderStatus,
  renderActivityType,
  findZongcuIcon,
  ACTIVITY_TYPE,
  CREATESTATUS,
} from '@/constants/zongcu';
import history from '@/history';
import RangePicker from '@/form-component/range-picker';
import apis from '../../../../apis';
import { MenuOutlined, AppstoreOutlined } from '@ant-design/icons';
import { Link, withRouter } from 'react-router-dom';
import './index.less';
import { formateTimeStamp } from '@/common/utils';
import { prefixCls } from '@/constants';
import WarningInfo from '@/components/warning-info';
import ZongCuList from '@/components/zongcu-list';
import classnames from 'classnames';
import FormBoxes from '@/components/filter-new-boxes';
import Card from '@/components/card';
import Copy from '@/components/copy';
import useGetFirstData from '@/hooks/useGetZCFirstData';
import useDidUpdate from '@/hooks/useDidUpdate';
import { connect, useSelector } from 'react-redux';
import { setDailyCreate } from '@/store/zongzu-form';
import { commonServiceGetBeCreatedData } from '../../../../../../activity-manage/detail/apis';
import SaleNoAuthModal from '@/components/nopower/noPower-modal';
import Empty from '@/components/core-empty';

const { Option } = Select;

const ZongcuActivity = (props) => {
  // 存放搜索框内容
  const initalState = {
    currentPage: 1,
    pageSize: 10,
  };
  const userInfo = useSelector((state: any) => state.userInfo);
  const [conditions, setConditions] = useState(initalState);
  const [listConditions, setListConditions] = useState(initalState);
  // 是否作废
  const [otherConditions, setOtherConditions] = useState({ suspendStatus: '' });

  const initialContent = {
    list: [],
    totalPage: '',
    totalCount: '',
    loading: '',
  };

  const [content, setContent] = useState(initialContent);
  const [listContent, setListContent] = useState(initialContent);

  const [searchForm] = Form.useForm();
  const timeout = useRef(null);
  const [cardCurrPage, setCardCurrPage] = useState(1);
  const [type, setType] = useState('list');
  const [authList, setAuthList] = useState([]);
  const [authShowType, setAuthShowType] = useState();
  const noAuthModalRef = useRef(null);
  const [more, setMore] = useState(false);
  const [applyValidStatus, setApplyValidStatus] = useState(null);
  const [zongcuCategoryList, setZongcuCategoryList] = useState([]);
  const [activityCategoryLoading, setActivityCategoryLoading] = useState(false);
  const [createZongcuActivityVisible, setCreateZongcuActivityVisible] = useState(false);

  const getInitialContent = useGetFirstData(apis.zongcuMylist, props.zongcuFormInfo);

  useEffect(() => {
    setContent(getInitialContent);
    setListContent(getInitialContent);
  }, [getInitialContent]);

  useEffect(() => {
    if (JSON.stringify(props.zongcuFormInfo) === '{}') return;
    searchForm.setFieldsValue(props.zongcuFormInfo);
    onFinish(props.zongcuFormInfo);
    // eslint-disable-next-line
  }, [props.zongcuFormInfo]);

  // 请求主接口数据
  /* eslint-disable */
  useDidUpdate(() => {
    if (!more) {
      setContent((data) => ({ ...data, loading: true }));
    }

    const allConditions = Object.assign({}, conditions, otherConditions);

    apis
      .zongcuMylist(allConditions)
      .then((res) => {
        const {
          ret,
          data: { list = [], totalPage, totalCount },
        } = res;
        if (ret === '0') {
          if (more) {
            setContent({
              list: content.list.concat(list),
              loading: false,
              totalPage,
              totalCount,
            });
          } else {
            setContent({
              list: list,
              loading: false,
              totalPage,
              totalCount,
            });
          }
        } else {
          message.error(res.msg);
          setContent({
            loading: false,
            ...content,
          });
        }
      })
      .catch((ex) => {
        message.error(ex);
        setContent({
          loading: false,
          ...content,
        });
      });
  }, [conditions, otherConditions]);
  /* eslint-enable */

  // 请求主接口数据
  /* eslint-disable */
  useDidUpdate(() => {
    const allConditions = Object.assign({}, listConditions, otherConditions);

    apis
      .zongcuMylist(allConditions)
      .then((res) => {
        const {
          ret,
          data: { list = [], totalPage, totalCount },
        } = res;
        if (ret === '0') {
          setListContent({
            list,
            loading: false,
            totalPage,
            totalCount,
          });
        } else {
          message.error(res.msg);
          setListContent({
            loading: false,
            ...listContent,
          });
        }
      })
      .catch((ex) => {
        message.error(ex);
        setListContent({
          loading: false,
          ...listContent,
        });
      });
  }, [listConditions, otherConditions]);
  /* eslint-enable */

  const authInformation = useCallback(async () => {
    const { ret, msg, data } = await commonServiceGetBeCreatedData({ channel: 0 });
    if (ret === '0') {
      setAuthList(data?.list || []);
      // data?.showType === 0 && setNoAuthModalVisible(true);
      setAuthShowType(data?.showType);
    } else {
      message.error(`${msg || '获取异常,请您稍后重试！'}`);
    }
  }, []);

  useEffect(() => {
    authInformation();
  }, [authInformation]);

  const onFinish = (values = {}) => {
    setMore(false);
    props.setZongcuInfo(values);
    const { activityTime = [], onlineFlag = '', macActId = '', zongcuName = '', activityTypes = '' } = values;
    let startQueryTime, endQueryTime;

    if (activityTime && activityTime.length > 0) {
      startQueryTime = activityTime[0].valueOf();
      endQueryTime = activityTime[1].valueOf();
    }
    if (type == 'card') {
      setConditions({
        ...conditions,
        ...initalState,
        activityTypes,
        startQueryTime,
        endQueryTime,
        onlineFlag,
        name: zongcuName,
        macActId,
      });
    } else {
      setListConditions({
        ...listConditions,
        ...initalState,
        activityTypes,
        startQueryTime,
        endQueryTime,
        onlineFlag,
        name: zongcuName,
        macActId,
      });
    }
  };

  // 点击“新建综促活动按钮”
  function createZongcuActivity() {
    window.log && window.log('yx_center', 'createzongcuactivity', `{"zongcutab":"1"}`);
    authInformation();
    if (authShowType === 0) {
      noAuthModalRef.current.show({ resCode: '5-3-1' });
    } else {
      setActivityCategoryLoading(true);
      // 显示弹窗
      setCreateZongcuActivityVisible(true);
      // 调用erp权限下的可创建综促活动接口
      commonServiceGetBeCreatedData({ channel: 0 })
        .then((res) => {
          if (res && res.ret === '0' && res.data.list) {
            setActivityCategoryLoading(false);
            // 活动权限保留，仅前端过滤平台促销类型
            setZongcuCategoryList(res.data.list?.filter((item) => item.code !== 107) || []);
          }
        })
        .catch((err) => {
          console.log(err);
          setActivityCategoryLoading(false);
        });
    }
  }

  function renderPopItem(item) {
    const { name = '', icons = null } = findZongcuIcon(item.code);
    if (!name) return null;
    if (item.status === 1) {
      if (item.code === -1 && authShowType === 2) {
        return (
          <div className="item" key={item.code} onClick={() => history.push('/system/authSetting?resCode=5-3-1')}>
            {icons}
            <div>{name}</div>
          </div>
        );
      }
      return (
        <Link
          className="item"
          key={item.code}
          onClick={() => {
            if (item.code === 122) {
              window.log && window.log('gwk', 'chuangjian', `{"erp": ${userInfo?.userMap?.erp}}`);
            }
          }}
          to={`/activity-manage/myCreate/zongcuActivity/myCreate/create/activityManage/create?activity_type=${item.code}`}
        >
          {icons}
          <div>{name}</div>
        </Link>
      );
    } else {
      return (
        <Tooltip title="当前主题活动下已存在打标活动" key={item.code}>
          <div className="item noUse">
            {icons}
            <div>{name}</div>
          </div>
        </Tooltip>
      );
    }
  }

  function toLoadingMore() {
    setMore(true);
    setConditions({ ...conditions, currentPage: cardCurrPage + 1 });
    setCardCurrPage(cardCurrPage + 1);
  }

  function reset() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {}, 1000);
  }

  function toTB(id, activityStatus) {
    if (activityStatus === 1) {
      props.history.push(
        `/activity-manage/myCreate/zongcuActivity/myCreate/detail/activityManage/qualificationSetting?activity_id=${id}`
      );
    } else if (activityStatus === 2) {
      props.history.push(
        `/activity-manage/myCreate/zongcuActivity/myCreate/detail/activityManage/resourceAllocation?activity_id=${id}`
      );
    } else {
      props.history.push(
        `/activity-manage/myCreate/zongcuActivity/myCreate/detail/activityManage/detail?activity_id=${id}&flow_type=0`
      );
    }
  }

  // 渲染卡片本身
  function renderCardItem(item) {
    return (
      <Card
        key={item.id}
        className="zongcu-card-item"
        shadow
        container={{
          padding: { vertical: 'normal', horizontal: 'normal' },
          margin: false,
        }}
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.02)', border: '1px solid #e9e9e9' }}
        onClick={() => toTB(item.id, item.activityStatus)}
      >
        <div className="content">
          <div className="title" onClick={(e) => e.preventDefault()}>
            <Tooltip title={item.name}>
              <div className="title-act-name">{item.name}</div>
            </Tooltip>
            <Divider type="vertical" />
            <div className={renderCardStatusColor(item.applyStatus)}>{renderStatus(item.applyStatus)}</div>
          </div>
          <div className="status-wrap">
            <div className={item.isRelated === 1 ? 'activity-isRelated' : ''}>
              {item.isRelated === 1 ? '主题活动' : ''}
            </div>
            {!!item.crossProduct && <div className="activity-type">跨品类营销</div>}
            <Tooltip title={renderActivityType(item.activityType).name}>
              <div className="activity-type">{renderActivityType(item.activityType).text}</div>
            </Tooltip>
          </div>
          <div className="ID-title">
            活动编号：
            <span className="ID">
              <Copy text={item.macActId} size="small" />
            </span>
          </div>
          <div className="time-title">
            活动时间：<span className="startTime">{formateTimeStamp(item.beginTime, true)}</span>
          </div>
          <div className="endTime">{formateTimeStamp(item.endTime, true)}</div>
        </div>
      </Card>
    );
  }

  function switchStatusType(applyValidStatus) {
    setMore(false);
    setApplyValidStatus(applyValidStatus);
    setCardCurrPage(1);
    type == 'card'
      ? setConditions({ ...conditions, forUnPublish: applyValidStatus, currentPage: 1 })
      : setListConditions({ ...listConditions, forUnPublish: applyValidStatus, currentPage: 1 });
  }

  const formItemArr = [
    <Form.Item name="macActId" label="活动编号" key={1} span={6} colon={false}>
      <InputNumber placeholder="请输入活动编号" controls={false} />
    </Form.Item>,
    <Form.Item name="zongcuName" label="活动名称" key={2} span={6} colon={false}>
      <Input placeholder="请输入活动名称" />
    </Form.Item>,
    <Form.Item name="activityTime" label="活动时间" rules={[{ type: 'array' }]} key={3} span={6} colon={false}>
      <RangePicker
        style={{ width: '100%' }}
        format={['YYYY-MM-DD']}
        className={prefixCls + '-picker-full-size'}
        placeholder={['开始时间', '结束时间']}
      />
    </Form.Item>,
    <Form.Item name="onlineFlag" label="状态" key={4} span={6} colon={false}>
      <Select placeholder="全部" allowClear className="all-about-me-signed-activity-select">
        {MYCREATESTATUS.map((item) => (
          <Option key={item.val} value={item.val}>
            {item.title}
          </Option>
        ))}
      </Select>
    </Form.Item>,
    <Form.Item name="activityTypes" label="综促类型" key={5} span={6} colon={false}>
      <Select placeholder="不限" allowClear className="all-about-me-signed-activity-select">
        {ACTIVITY_TYPE.map((item) => (
          <Option key={item.value} value={item.value}>
            {item.name}
          </Option>
        ))}
      </Select>
    </Form.Item>,
  ];

  const btnInitialForm = (
    <>
      <Form.Item>
        <Button type="primary" htmlType="submit" shape="round">
          查询
        </Button>
      </Form.Item>
      <Form.Item>
        <Button
          onClick={() => {
            searchForm.resetFields();
            onFinish();
          }}
          shape="round"
        >
          重置
        </Button>
      </Form.Item>
    </>
  );

  return (
    <div className="my-create-zongcu-wrap">
      <div className="zongcu-search">
        <div style={{ display: 'flex', marginBottom: '16px' }}>
          <div className="applied-status-key-fa common-filter-key">报名状态：</div>
          <div className="applied-status-val-fa">
            {Object.values(CREATESTATUS) &&
              Object.values(CREATESTATUS)?.map((item) => {
                return (
                  <span
                    key={item.value}
                    className={classnames(
                      item.value === applyValidStatus ? 'common-filter-val choosed' : 'common-filter-val',
                      'applied-status-item'
                    )}
                    onClick={() => switchStatusType(item.value)}
                  >
                    {item.name}
                  </span>
                );
              })}
          </div>
        </div>
        <Form form={searchForm} onFinish={onFinish}>
          <FormBoxes formItemArr={formItemArr} btnForm={btnInitialForm} />
        </Form>
      </div>
      <div className="zongcu-applied-status-fa">
        <Checkbox
          checked={otherConditions.suspendStatus === 0}
          onChange={(ev) => {
            setOtherConditions({ suspendStatus: ev.target.checked ? 0 : '' });
            if (type == 'card') {
              setConditions({ ...conditions, currentPage: 1 });
              setMore(false);
            } else {
              setListConditions({ ...listConditions, currentPage: 1 });
            }
          }}
          style={{ marginLeft: '10px' }}
        >
          仅展示未作废的活动
        </Checkbox>
        <div className="change-style">
          <Space size={20}>
            <MenuOutlined
              className={type == 'list' ? 'icon selected' : 'icon'}
              onClick={() => {
                setType('list');
              }}
            />
            <AppstoreOutlined
              className={type == 'card' ? 'icon selected' : 'icon'}
              onClick={() => {
                setType('card');
              }}
            />
            <div className="zongcu-btn">
              <Button type="primary" onClick={createZongcuActivity} shape="round">
                +新建综合促销
              </Button>
            </div>
          </Space>
        </div>
      </div>
      <WarningInfo
        info={
          <span>
            除了在此处创建和管理综合促销，您也可以<Link to="/activity-manage">【点击这里】</Link>
            去创建主题活动下的综合促销。
          </span>
        }
      ></WarningInfo>

      {type == 'list' ? (
        <div className="zongcu-list-wrap">
          <ZongCuList
            data={listContent}
            conditions={listConditions}
            setConditions={setListConditions}
            toTB={toTB}
            flag="create"
          />
        </div>
      ) : (
        <>
          {!content.loading ? (
            content.list.length > 0 ? (
              <div className="zongcu-card-wrap">
                {content.list.map((item) => {
                  return renderCardItem(item);
                })}
                {conditions.currentPage < content.totalPage ? (
                  <div className="zongcu-loading-more" onClick={toLoadingMore}>
                    更多 &gt;
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="zongcu-empty">
                <Empty style={{ color: 'rgba(0,0,0,0.82)' }} />
              </div>
            )
          ) : (
            <div className="zongcu-spin">
              <Spin />
            </div>
          )}
        </>
      )}
      <SaleNoAuthModal ref={noAuthModalRef} />

      <Modal
        width={zongcuCategoryList.length > 7 ? 1000 : 640}
        title="新建综合促销"
        footer={null}
        visible={createZongcuActivityVisible}
        onCancel={() => setCreateZongcuActivityVisible(false)}
      >
        {activityCategoryLoading ? (
          <div className="zongcu-pop-spin">
            <Spin />
          </div>
        ) : (
          <>
            <div style={{ color: 'rgba(0, 0, 0, 0.65)' }}>
              请选择综促类型
              {!zongcuCategoryList.find((item) => item.code === 108) && (
                <span style={{ paddingLeft: 5, color: 'red' }}>
                  创建优惠券请先至“系统设置-权限管理”中申请“优惠券活动创建”权限。
                </span>
              )}
            </div>
            <div className={zongcuCategoryList.length >= 7 ? 'select-zongcu-category' : 'select-zongcu-category-new'}>
              {zongcuCategoryList.map((item) => {
                return renderPopItem(item);
              })}
            </div>
          </>
        )}
      </Modal>
    </div>
  );
};

const _ZongcuActivity = connect(
  (state) => {
    return {
      zongcuFormInfo: state.zongcuFormInfo.dailyCreate,
    };
  },
  (dispatch) => {
    return {
      setZongcuInfo(props) {
        dispatch(setDailyCreate(props));
      },
    };
  }
)(ZongcuActivity);

export default withRouter(_ZongcuActivity);
